import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { queryAreaTreeList, queryUserTreeList, setAreaDistribution, getAreaUser } from '@/api/api';
var columns = [{
  title: '区域名称',
  dataIndex: 'label',
  key: 'label'
}, {
  title: '操作',
  dataIndex: 'action',
  scopedSlots: {
    customRender: 'action'
  },
  align: 'center',
  width: 150
}];
export default {
  data: function data() {
    return {
      bindShow: false,
      // 表头
      columns: columns,
      loading: false,
      dataSource: [],
      treeData: [],
      checkedKeys: [],
      selectData: null
    };
  },
  mounted: function mounted() {
    this.loadData();
    this.loadTree();
  },
  methods: {
    getAreaUserInfo: function getAreaUserInfo(id) {
      var _this = this;

      getAreaUser(id).then(function (res) {
        _this.checkedKeys = res.result.split(',');
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var userList = [];
      this.checkedKeys.forEach(function (item) {
        if (item.indexOf('_') == -1) {
          userList.push(item);
        }
      });
      setAreaDistribution({
        areaId: this.selectData.key ? JSON.parse(this.selectData.key) : '',
        userId: userList.join(',')
      }).then(function (res) {
        if (res.success) {
          _this2.$message_custom(res.message);

          _this2.bindShow = false;
        }
      });
    },
    onCheck: function onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    handleEdit: function handleEdit(record) {
      this.selectData = record;
      this.getAreaUserInfo(record.key);
      this.bindShow = true;
    },
    loadTree: function loadTree() {
      var _this3 = this;

      queryUserTreeList().then(function (res) {
        if (res.success) {
          _this3.treeData = _toConsumableArray(res.result);
        }
      });
    },
    loadData: function loadData() {
      var _this4 = this;

      this.dataSource = [];
      queryAreaTreeList().then(function (res) {
        if (res.success) {
          _this4.dataSource = res.result;
        }
      });
    }
  }
};